<template>
  <div>
    <div class="location"><i class="fa fa-map-marker" aria-hidden="true"></i> {{activity.city}}, <span v-if="activityRegion">{{activityRegion}},</span> Portugal</div>
    <div class="activityIcons m-t-1">
      <div>
        <span v-if="activity.allows_instant_booking">
          <i class="fa fa-bolt"></i> <span>{{t('Allows instant booking')}}</span>
        </span>
        <span><i class="fa fa-clock-o"></i> {{humanDuration}}
        </span>
        <span>
          <i class="fa fa-child"></i> <span v-if="activity.minimum_age != 0">{{t('Minimum age')}}: {{activity.minimum_age}} {{t('years old')}}</span><span v-else>{{t('Allows any age')}}</span>
        </span>
        <span>
          <i class="fa fa-comments-o" v-if="activity.translations[language].spoken_languages"></i> {{activity.translations[language].spoken_languages}}
        </span>
      </div>
      <div>
        <span v-if="activity.is_nature_tourism">
          <i class="fa fa-tree"></i> {{t('Activity recognized as Nature Tourism')}}
        </span>
        <span v-if="activity.is_low_mobility_accessible">
          <i class="fa fa-wheelchair"></i> {{t('Accessible to low mobility people')}}
        </span>
        <span v-if="activity.is_priced_per_occurrence">
          <i class="fa fa-users"></i> {{t('Group activity')}} ({{activity.group_min}} – {{activity.group_max}} {{t('participants')}})
        </span>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex';

const moment = window.moment;

export default {
  name: 'DescriptionHeader',
  props: {
    activity: { default: {} },
  },
  computed: {
    ...mapState({
      language: state => state.language,
    }),
    ...mapGetters([
      'activityRegion',
    ]),
    humanDuration() {
      const hours = moment.duration(this.activity.duration, 'minutes').hours();
      let minutes = moment.duration(this.activity.duration, 'minutes').minutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      return `${hours}h${minutes}`;
    },
  },
};

</script>


<style scoped lang="scss">
.activityIcons {
  font-size: 13px;
  line-height: 32px;
  span {
    white-space: nowrap;
    padding-right: 1em;
  }
}

.fa {
  font-size: 16px;
  margin-right: 0.3em;
}
.fa-bolt {
  color: #FF8800;
}
.fa-clock-o, .fa-child, .fa-comments-o, .fa-tree, .fa-users, .fa-map-marker {
  color: #00B48D;
}
.fa-wheelchair {
  color: #00BCD4;
}

.location {
  font-size: 0.9rem;
}

</style>



// WEBPACK FOOTER //
// DescriptionHeader.vue?5d6e54a4